import { useEffect, useState } from 'react';
import { supabase } from '@services/supabase/client';
import { getRoleDisplayName, getStatusDisplayName, getStatusColor } from '@/types/staff';
import type { StaffUser } from '@/types/staff';

export const UserManagement = () => {
  const [staff, setStaff] = useState<StaffUser[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStaff();
  }, []);

  const loadStaff = async () => {
    const { data, error } = await supabase
      .from('staff_users')
      .select('*')
      .order('created_at', { ascending: false });

    if (!error && data) {
      setStaff(data);
    }
    setLoading(false);
  };

  const approveStaff = async (staffId: string, currentUser: StaffUser) => {
    await ((supabase
      .from('staff_users') as any)
      .update({
        status: 'active',
        approved_by: currentUser.id,
        approved_at: new Date().toISOString(),
      })
      .eq('id', staffId));
    
    loadStaff();
  };

  if (loading) return <div>Loading staff...</div>;

  return (
    <div>
      <h2>User Management</h2>
      <p className="text-secondary">Manage staff users, roles, and permissions</p>
      
      <div className="table-container" style={{ marginTop: 'var(--spacing-xl)' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Last Login</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {staff.map((s) => (
              <tr key={s.id}>
                <td className="font-weight-600">
                  {s.first_name} {s.last_name}
                </td>
                <td className="text-small">{s.email}</td>
                <td className="text-small">{getRoleDisplayName(s.role)}</td>
                <td>
                  <span className={`status-badge status-${getStatusColor(s.status)}`}>
                    {getStatusDisplayName(s.status)}
                  </span>
                </td>
                <td className="text-small">
                  {s.last_login_at ? new Date(s.last_login_at).toLocaleDateString() : 'Never'}
                </td>
                <td>
                  {s.status === 'pending_approval' ? (
                    <button
                      onClick={() => {
                        const currentUser = staff.find(u => u.status === 'active');
                        if (currentUser) approveStaff(s.id, currentUser);
                      }}
                      className="btn btn-primary btn-small"
                    >
                      Approve
                    </button>
                  ) : (
                    <button className="btn btn-ghost btn-small">Edit</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

